module.exports = __webpack_public_path__ + "img/header-8.9ed495cb.png";